import api from "@/services/api";
import { createAction, createAsyncThunk } from "@reduxjs/toolkit";
import axios from "axios";
import { ListParams } from "../types/common";
import { SaveSchoolHistoryPayload } from "../types/schoolHistoryType";

export const getSchoolHistoryList = createAsyncThunk("/schoolHistory/list", async (params: ListParams = {}) => {
  const query = new URLSearchParams();
  if (params.page) query.set("page", String(params.page));
  if (params.limit) query.set("limit", String(params.limit));
  if (params.keyword) query.set("keyword", params.keyword);
  const response = (await api.get(`/schoolhistory?${query.toString()}`)).data;
  return response;
});

export const setSchoolHistoryUploadProgress = createAction<number>("/schoolHistory/uploadProgress");

export const saveSchoolHistory = createAsyncThunk(
  "/schoolHistory/save",
  async (payload: SaveSchoolHistoryPayload, { dispatch }) => {
    try {
      const response = (
        await api.post("/schoolhistory/action", payload, {
          onUploadProgress: (event) => {
            if (event.total) dispatch(setSchoolHistoryUploadProgress(Math.round((event.loaded / event.total) * 100)));
          },
        })
      ).data;
      return response;
    } catch (error) {
      // Surface transport failures (413, timeout, offline) through the normal response flow so the admin sees them.
      const status = axios.isAxiosError(error) ? error.response?.status : undefined;
      const message =
        status === 413
          ? "Ukuran file terlalu besar untuk server. Kompres video atau gunakan link YouTube."
          : axios.isAxiosError(error) && error.response?.data?.message
            ? error.response.data.message
            : "Gagal menyimpan. Periksa koneksi lalu coba lagi.";
      return { status: status ?? 500, message };
    }
  }
);

export const deleteSchoolHistory = createAsyncThunk("/schoolHistory/delete", async (id: number) => {
  const response = (await api.get(`/schoolhistory/delete/${id}`)).data;
  return response;
});
